'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility');

var _ramda = require('ramda');

var _tracking_utility = require('common-utilities/src/tracking_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NetInflowOutflowChart = function (_React$Component) {
  _inherits(NetInflowOutflowChart, _React$Component);

  function NetInflowOutflowChart(props) {
    _classCallCheck(this, NetInflowOutflowChart);

    var _this = _possibleConstructorReturn(this, (NetInflowOutflowChart.__proto__ || Object.getPrototypeOf(NetInflowOutflowChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  /* eslint-disable*/


  _createClass(NetInflowOutflowChart, [{
    key: 'createNetInflowOutflowChart',
    value: function createNetInflowOutflowChart(printWidth) {
      var data = this.props.netInflowOutflowData;
      var imgUrl = this.props.gaiaRedirectUrl;
      var isDesktop = this.props.breakpoint > 3;
      var numXAxisTicks = isDesktop ? 7 : 3;
      var tickInterval = isDesktop ? 1 : 3;
      var dateArray = data.map(function (d) {
        return d.date;
      });
      var xAxisTicks = _date_formatter2.default.getBusinessDatesFromGivenDateArray(numXAxisTicks, tickInterval, dateArray);
      var marginLeft = 50;
      var fontSize = "14px";
      var marginRight = isDesktop ? 20 : 10;
      var self = this;

      var spec = (0, _ramda.mergeDeepLeft)(_chart_utility.COMMON_CHART_CONFIG, {
        "padding0": 0,
        "padding1": 0,
        "selector": "#NetInflowOutflowChart",
        "label": {
          "show": false
        },
        "keys": ["date"],
        "values": ["netFlowAmount"],
        "container": {
          "marginBottom": 70,
          "marginLeft": marginLeft,
          "marginRight": marginRight,
          "height": 500
        },
        "scaled": true,
        "dateFormat": "%Y-%m-%d",
        "style": {
          "fill": function fill(d) {
            return d.netFlowAmount > 0 ? "#70C4FF" : "#00A16D";
          }
        },
        "mouseoverHandler": function mouseoverHandler(d, node) {
          if (!self.trackChartHover) {
            _tracking_utility.TrackingUtility.trackEvent({
              "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
              "eventAction": "net inflows/outflows chart",
              "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
            });
            self.trackChartHover = true;
          }

          if (d3.select(node).select("#definition").empty()) {
            var def = d3.select(node).append("defs").attr("id", "definition");

            def.append("pattern").attr("id", "pattern0").attr("patternContentUnits", "objectBoundingBox").attr("width", 2.5).attr("height", "0.162602").append("use").attr("xlink:href", "#image0_859_24439").attr("transform", "scale(0.0625 0.00406504)");
            def.append("image").attr("id", "image0_859_24439").attr("width", 40).attr("height", 40).attr("xlink:href", imgUrl + "/images/overlay.png");
          }
          var width = d3.select(node).node().getBBox().width;
          var height = d3.select(node).node().getBBox().height;

          if (d3.select(node).select("#patternRect").empty()) {
            d3.select(node).append("rect").attr("height", height).attr("width", width).attr("id", "patternRect").style("fill", "url(#pattern0)");
          }
        },
        "mouseoutHandler": function mouseoutHandler(d, node) {
          if (d3.event.relatedTarget.id === "patternRect") {
            return;
          }

          if (!d3.select(node).select("#definition").empty()) {
            d3.select(node).select("#definition").remove();
          }

          if (!d3.select(node).select("#patternRect").empty()) {
            d3.select(node).select("#patternRect").remove();
          }
        },
        "axis": {
          "x": {
            "show": true,
            "label": {
              "show": true,
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              },
              "text": function text(d) {
                return _date_formatter2.default.getDateInESTFormat(d);
              }
            },
            "tick": {
              "padding": 5,
              "values": xAxisTicks
            },
            "domain": [xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]]
          },
          "y": {
            "show": true,
            "label": {
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              },
              "text": function text(d) {
                var absValue = Math.abs(d);
                if (absValue >= 1000000 && absValue < 1000000000) {
                  d = d / 1000000;
                  return d3.format("-$,")(d) + "M";
                }
                if (absValue >= 1000000000) {
                  d = d / 1000000000;
                  return d3.format("-$,")(d) + "B";
                }
                if (d === 0) {
                  return "0";
                }
              }
            },
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            }
          }
        },
        "tooltip": {
          "show": true,
          "type": "snap",
          "position": function position(d) {
            return d.netFlowAmount > 0 ? "bottom" : "top";
          },
          "arrow": {
            "show": true,
            "height": 10,
            "width": 20
          },
          "style": {
            "font-size": fontSize
          },
          "text": function text(data) {
            var tooltiptext = "<div style ='padding:2px'>";

            for (var prop in data) {
              if (prop === "date") {
                tooltiptext += "<div style= 'text-align:left;  font-weight:100;' class='caption'> " + _date_formatter2.default.getDateInESTFormat(data[prop]) + "</div>";
              } else if (prop === "netFlowAmount") {
                if (data[prop] > 0) {
                  tooltiptext += "<div style = 'text-align:left;'><span class='caption' style='font-weight: 400; color: #00a22a'>" + d3.format("+$,")(data[prop]) + "</span> </div>";
                } else {
                  tooltiptext += "<div style= 'text-align:left;'><span class='caption' style='font-weight: 400; color: #e20000'>" + d3.format("+$,")(data[prop]) + "</span> </div>";
                }
              }
            }
            tooltiptext += "</div> ";
            return tooltiptext;
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }

      });

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility.getChartPrintHeight)();
      }

      return (0, _chart_utility.generateChart)((0, _chart_utility.generateChartId)("NetInflowOutflowChart", printWidth && typeof printWidth === "number"), "bar", data, spec);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.netInflowOutflowData.length === 0) {
        return null;
      }
      var chart = this.createNetInflowOutflowChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(chart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createNetInflowOutflowChart(800))
        )
      );
    }
  }]);

  return NetInflowOutflowChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = NetInflowOutflowChart;